import Image from 'next/image';
import type React from 'react';

import {
  CraftLogo as RootCraftLogo,
  type CraftLogoProps as RootCraftLogoProps,
} from '@craft/ui/components/brand';

import * as constants from './constants';

interface CraftLogoProps extends Omit<RootCraftLogoProps, 'component' | 'src'> {
  readonly logoType?: constants.CraftLogoType;
}

export const CraftLogo: React.FC<CraftLogoProps> = ({
  logoType = constants.CraftLogoType.REGULAR,
  ...props
}) => <RootCraftLogo {...props} component={Image} src={constants.CraftLogoSrcs[logoType]} />;
